export default function valuta(value?: string | number, showSign?: boolean) {
  return new Intl.NumberFormat('nl-NL', {
    maximumFractionDigits: 0,
    style: showSign ? 'currency' : undefined,
    currency: showSign ? 'EUR' : undefined
  }).format(Number(value?.toString()))
}
